import { makeStyles, MenuItem, TextField, withWidth } from "@material-ui/core";
import { css, cx } from "emotion";
import React from "react";
import { StyledPagination } from "../CustomStyles/CustomPagination";

const styledPagination = css`
  li button {
    border: none !important;
    background-color: #bdbdbd !important;
    color: #757575 !important;
    border-radius: 8px !important;

    &:selected {
      outline: none !important;
    }

    &:active {
      outline: none !important;
    }

    &:focus {
      outline: none !important;
    }
  }

  li button.Mui-selected {
    border: none !important;
    background-color: #2196f3 !important;
    color: #ffffff !important;
  }
`;

const styledSelectPagination = css`
  background-color: #ffffff !important;
  color: #212121 !important;
  font-size: 12px;
  border: 1px solid #eeeeee;
  border-radius: 8px !important;

  & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiSelect-outlined {
    background-color: #ffffff !important;
    color: #212121 !important;
    font-size: 12px;
    border: 1px solid #eeeeee;
    border-radius: 8px !important;
    padding: 9px 12px;
    padding-right: 63px !important;
  }
`;
const IzyPagination = (props) => {
  const { width, totalPage, onChangePage, onChangePerPage } = props;
  const [perPage, setPerPage] = React.useState(props.perPage);
  const [page, setPage] = React.useState(props.page);
  const handlePageChange = (event, value) => {
    setPage(value);
    onChangePage(value);
  };

  const handlePerPageChange = (e) => {
    handlePageChange(e, 1);
    setPerPage(e.target.value);
    onChangePerPage(e.target.value);
  };

  React.useEffect(() => {
    setPage(props.page);
  },[props.page]);

  return (
    <div className="my-3 row">
      <div
        className={
          width === "sm" || width === "xs"
            ? "col-sm-3 col-12 text-center mb-3"
            : "col-sm-3 col-12"
        }
      >
        <TextField
          className={styledSelectPagination}
          value={perPage}
          label=""
          variant="outlined"
          onChange={(e) => handlePerPageChange(e)}
          select
        >
          <MenuItem value={5}>5/page</MenuItem>
          <MenuItem value={10}>10/page</MenuItem>
          <MenuItem value={20}>20/page</MenuItem>
          <MenuItem value={25}>25/page</MenuItem>
          <MenuItem value={50}>50/page</MenuItem>
        </TextField>
      </div>
      <div className="col-sm-6 col-12 text-center">
        <div className="d-flex justify-content-center align-items-center h-100">
          <StyledPagination
            count={totalPage || 1}
            page={page}
            variant="outlined"
            shape="rounded"
            className={styledPagination}
            onChange={handlePageChange}
          />
        </div>
      </div>
      <div className="col-sm-3 col-12"></div>
    </div>
  );
};

export default withWidth()(IzyPagination);
